module.exports = __webpack_public_path__ + "static/media/exide-valve-regulated-lead-acid.2efce288.svg";